import styled from 'styled-components';
import StyledResponsiveImg from '../../../ResponsiveImg/StyledResponsiveImg';

const HoverImage = StyledResponsiveImg`
  height: 321px;
  width: auto;
  background: white;
  margin-top: 7px;
`;

const HoverImageColumn = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: ${({ marginLeft }) => marginLeft};
  margin-right: ${({ marginRight }) => marginRight};
`;

export { HoverImage, HoverImageColumn };
